<template>
    <div class="mb-5">
        <b-field>
            <b-input placeholder="Search..."
                     type="search"
                     icon="magnify"
                     expanded v-model="input" @input="typing">
            </b-input>
            <p class="control">
                <b-button type="is-primary">Search</b-button>
            </p>
        </b-field>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        data() {
            return {
                input: ''
            }
        },
        created() {
            this.typing = _.debounce(this.typing.bind(this), 250);
            this.input = new URLSearchParams(window.location.search).get('search');
        },
        methods: {
            emit() {
                this.$emit('searching', this.input);
            },
            typing() {
                this.emit();
            }
        }
    }
</script>